// extracted by mini-css-extract-plugin
module.exports = {"OnlineStoreRightsAcPro":"OnlineStoreRightsAcPro_OnlineStoreRightsAcPro__f8iIh"};